import styles from './PortalFormRow.module.css'

const PortalFormRow = ({children}) => {
    return<div className={styles.portalFormRowContainer}>{children}</div>
}

export default PortalFormRow;